import {gql} from "@apollo/client";

export const GET_DASHBOARD_DATA = gql`
    query GetDashboardData {
        getDashboardData {
            totalProperties
            occupiedProperties
            vacantProperties
            inProgressProperties
            totalLandlords
            totalTenants
            recentProperties {
                id
                address {
                    street
                    suburb
                    city
                    postalCode
                }
                status
                landlord {
                    firstName
                    lastName
                }
                tenant {
                    firstName
                    lastName
                }
            }
        }
    }`;

